import React, { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import { toast } from 'react-toastify'
import { FiCheck, FiEdit, FiPlus, FiSave, FiTrash } from 'react-icons/fi'

import { Container } from './styles'
import Card from '~/components/Card'
import Table from '~/components/Table'
import { api, authHeaders } from '~/services/api'
import Spinner from '~/components/Spinner'
import { Button, Textbox } from '~/components/Form'
import Modal from '~/components/Modal'

const baseInitialValues = {
	descricao: ''
}

export default function () {
	const [assuntos, setAssuntos] = useState(null)
	const [assuntoEmEdicao, setAssuntoEmEdicao] = useState(null)
	const [mostrarFormAssunto, setMostrarFormAssunto] = useState(false)
	const [initialValues, setInitialValues] = useState(baseInitialValues)

	async function loadAssuntos() {
		setAssuntos(null)

		const response = await api.get('/visita_diretoria/assunto', authHeaders())

		setAssuntos(response)
	}

	async function handleCadastrarAssunto(values) {
		try {
			await api.post('visita_diretoria/assunto', values, authHeaders())

			toast.success('Assunto cadastrado com sucesso.')

			setMostrarFormAssunto(false)

			loadAssuntos()
		} catch(e) {
			toast.error(e.msg)
		}
	}

	async function handleDeleteAssunto(item) {
		try {
			await api.delete(`visita_diretoria/assunto/${item.id}`, authHeaders())

			toast.success('Assunto removido com sucesso.')

			loadAssuntos()
		} catch(e) {
			toast.error(e.msg)
		}
	}

	async function handleUpdateAssunto(values) {
		try {
			await api.put(`visita_diretoria/assunto/${assuntoEmEdicao.id}`, values, authHeaders())

			toast.success('Assunto atualizado com sucesso.')

			setAssuntoEmEdicao(null)

			loadAssuntos()
		} catch(e) {
			toast.error(e.msg)
		}
	}

	useEffect(() => {
		loadAssuntos()
	}, [])

	useEffect(() => {
		if(assuntoEmEdicao) {
			setInitialValues({
				descricao: assuntoEmEdicao.descricao
			})
	
			setMostrarFormAssunto(true)
		} else {
			setInitialValues(baseInitialValues)
	
			setMostrarFormAssunto(false)
		}
	}, [assuntoEmEdicao])

	if(!assuntos) {
		return <Spinner />
	}

	return (
		<>
			<Container>
				<main>
					<Card>
						<h1>Assuntos</h1>

						<div className="flex flex-col">
							<Button className="transparent self-end" onClick={() => { setMostrarFormAssunto(true) }}>
								Novo assunto
								<FiPlus size={16} />
							</Button>

							<Table 
								headers={[
									{ name: 'descricao', value: 'Assunto' }
								]}
								data={assuntos}
								actions={[
									{
										action: setAssuntoEmEdicao,
										name: 'Atualizar',
										icon: FiEdit,
										iconSize: 16
									},
									{
										action: handleDeleteAssunto,
										name: 'Remover',
										icon: FiTrash,
										iconSize: 16,
										confirmation: 'Deseja realmente remover este assunto?'
									}
								]}
							/>
						</div>
					</Card>
				</main>
			</Container>

			<Modal
				isOpen={mostrarFormAssunto}
				handleClose={() => {
					setMostrarFormAssunto(false)

					setInitialValues(baseInitialValues)
				}}
				title="Novo assunto"
			>
				<Formik
					initialValues={initialValues}
					onSubmit={assuntoEmEdicao ? handleUpdateAssunto : handleCadastrarAssunto}
					enableReinitialize
				>
					{() => (
						<Form className="flex flex-col">
							<Textbox 
								name="descricao"
								label="Assunto"
							/>

							<Button type="submit" className="white self-end">
								{assuntoEmEdicao ? 'Salvar alterações' : 'Cadastrar'}
								{assuntoEmEdicao ? <FiSave size={16} /> : <FiCheck size={16} />}
							</Button>
						</Form>
					)}
				</Formik>
			</Modal>
		</>
	)
}
